// Bandeau « nouvelle version disponible » (26/10/2026) : vérifie toutes les
// 5 minutes et au retour sur l'onglet si une mise en ligne a eu lieu ; le
// rechargement reste au choix de l'utilisateur (saisie en cours préservée).
import { useEffect, useState } from "react";
import { currentMainScript, isOutdated } from "../utils/appVersion";

const EVERY_MS = 5 * 60 * 1000;

export default function NewVersionBanner() {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const mine = currentMainScript();
    if (!mine) return undefined; // développement : pas de fichier compilé
    let stopped = false;
    const check = async () => { if (!stopped && await isOutdated(mine)) setOutdated(true); };
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    const timer = setInterval(check, EVERY_MS);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);
    return () => { stopped = true; clearInterval(timer); document.removeEventListener("visibilitychange", onVisible); window.removeEventListener("focus", check); };
  }, []);

  if (!outdated) return null;
  return (
    <div role="alert" style={{ position: "fixed", bottom: 16, left: "50%", transform: "translateX(-50%)", zIndex: 99998, background: "#1a9e72", color: "#fff",
      padding: "10px 16px", borderRadius: 10, boxShadow: "0 4px 16px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", gap: 12, fontSize: 13, maxWidth: "calc(100% - 32px)" }}>
      <span>Une nouvelle version d'ExecPro360 est disponible : rechargez la page pour en profiter.</span>
      <button className="btn" style={{ background: "#fff", color: "#1a9e72", fontWeight: 700 }} onClick={() => window.location.reload()}>Recharger</button>
    </div>
  );
}
